import { apiService } from "./api";

export const userService = {
  // Get all users (admin only)
  getUsers: async (page = 1, limit = 10, search = "", role = "") => {
    const params = { page, limit };
    if (search) params.search = search;
    if (role && role !== "all") params.role = role;

    return await apiService.get("/users", { params });
  },

  // Create user (admin only)
  createUser: async (userData) => {
    return await apiService.post("/users", userData);
  },

  // Get user by ID
  getUserById: async (id) => {
    return await apiService.get(`/users/${id}`);
  },

  // Update user
  updateUser: async (id, userData) => {
    return await apiService.put(`/users/${id}`, userData);
  },

  // Reset user password
  resetPassword: async (id, password) => {
    return await apiService.patch(`/users/${id}/reset-password`, { password });
  },

  // Delete user
  deleteUser: async (id) => {
    return await apiService.delete(`/users/${id}`);
  },
};

export default userService;
